<template>
    <div v-if="getSplit('movoto-tour-CW-4266')" class="property-tourcta" :class="glb.splits['movoto-tour-CW-4266']">
        <div v-if="!getSplit('movoto-tour-CW-4266', 'on3')" class="text-bold">Request a virtual or in-person tour</div>
        <!-- on1: 3 panel buttons -->
        <div v-if="getSplit('movoto-tour-CW-4266', 'on1')">
            <button type="button" @click="openTourHotlead('asap')">
                <span class="f6">Tour</span>
                <span class="text-bold f4">ASAP</span>
            </button>
            <button type="button" @click="openTourHotlead('weekend')">
                <span class="f6">Tour</span>
                <span class="text-bold f4">This weekend</span>
            </button>
            <button type="button" @click="openTourHotlead('another')">
                <span class="f6">Tour</span>
                <span class="text-bold f4">Another time</span>
            </button>
        </div>
        <!-- on2: 3 links with bullet separators -->
        <div v-else-if="getSplit('movoto-tour-CW-4266', 'on2')">
            <button type="button" class="link text-bold" @click="openTourHotlead('asap')">ASAP</button>
            <span aria-hidden="true">•</span>
            <button type="button" class="link text-bold" @click="openTourHotlead('weekend')">This weekend</button>
            <span aria-hidden="true">•</span>
            <button type="button" class="link text-bold" @click="openTourHotlead('another')">Another time</button>
        </div>
        <!-- on3: single CTA link with calendar icon -->
        <div v-else-if="getSplit('movoto-tour-CW-4266', 'on3')">
            <button type="button" class="link text-bold" @click="openTourHotlead('single')">
                <i class="icon-calendar-add"></i>
                <span>Request a virtual or in-person tour</span>
            </button>
        </div>
    </div>
</template>

<script src="./property-tourcta.js"></script>


<style lang="scss">
@use "./property-tourcta.scss" as *;
</style>
